import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CHAT_SKILLS_QUERY_KEY } from 'src/UI/app-container/chats/useChatSkills';
import type { SiestaSkill } from '../types';

type SaveSkillParams = {
  id?: string;
  name: string;
  description: string;
  markdown: string;
  requiresSandbox: boolean;
  companyFilesVisible: boolean;
  canGenerateSuitabilityReports: boolean;
  isEnabled: boolean;
};

export default function useSaveTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveSkillParams) => {
      const body = {
        name: params.name,
        description: params.description,
        markdown: params.markdown,
        requiresSandbox: params.requiresSandbox,
        companyFilesVisible: params.companyFilesVisible,
        canGenerateSuitabilityReports: params.canGenerateSuitabilityReports,
        isEnabled: params.isEnabled,
      };
      if (params.id) {
        return api.put<SiestaSkill>(`/tenant/custom-skills/${params.id}`, body);
      }
      return api.post<SiestaSkill>('/tenant/custom-skills', body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] });
      queryClient.invalidateQueries({ queryKey: CHAT_SKILLS_QUERY_KEY });
    },
  });
}
